export const postPerPage = 10;
